
import classNames from 'classnames';
import { Container } from 'reactstrap';
import NavBar from './Navbar2';
import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import {FirebaseDB} from "../../FirebaseDB"
import AdComponent from './AdComponent';

// import { Link, useNavigate } from "react-router-dom";
// import { auth, logInWithEmailAndPassword,logout, signInWithGoogle } from "./firebase";



class HowtoCom2 extends React.Component {

  

  constructor(props) {
    super(props);

    this.state = {
//        login : Login
    }

    this.previousWidth = -1;
  }

  render() {
    return (
      <Container fluid className={classNames('content', { 'is-open': this.props.isOpen })}>
        {/* <NavBar toggle={this.props.toggle} /> */}

        {/* <LoginContext.login></LoginContext.login> */}

        <h3>Set event alarm by discord webhook</h3>
        <h5>if you don't know discord , click link </h5>
        <a href='https://support.discord.com/hc/en-us/articles/228383668-Intro-to-Webhooks' target="_blank" >
          discord webhook
          </a>

        <h5>-get your webhook URL </h5>

        <h5>-click checkbox "Send motion event alarm"</h5>
        <h5>-set your webhook URL</h5>
        <h5>-test your discord alarm by test button</h5>

        <img style={{ margin : 20}} height="360" width="360"  src='./img/discord.png'/>

        <img style={{ margin : 20}} height="360" width="164"  src='./img/event1.jpg'/>
        <img style={{ margin : 20}} height="360" width="164"  src='./img/event2.jpg'/>
        <img style={{ margin : 20}} height="360" width="164"  src='./img/event3.jpg'/>

        

      </Container>

      
    );
  }
}




export default HowtoCom2;
